import React from 'react';
import Button from './Button'
import ImageSlider from '../components/ImageSlider'
import ImageSliderSwiperjs from './ImageSliderSwiperjs';

const ColorsGlazesShapes = ({ sliderImageSliceData }) => {
    
    const sliceItem = sliderImageSliceData;
    const images = sliceItem.items.map(item => ({ image: item.image.fluid.src, imageSrcSet:item.image.fluid.srcSet , caption: "" }))

    return (
        <div className='ColorsGlazesShapes_Wrapper'>
            <div className='ColorsGlazesShapes_ColorsGlazes'>
                <div className='ColorsGlazesShapes_ColorsGlazes_Text'>
                    <h2 className='ColorsGlazesHeading'>
                        {sliceItem.primary.slider_title.text}
                    </h2>
                    <div className='ColorsGlazesDesc'>
                        {sliceItem.primary.slider_description.text}
                    </div>
                {sliceItem.primary.button_name.text !== '' &&
                    ( <Button
                        modifier="normal"
                        className="ColorsGlazes__Button"
                        link={sliceItem.primary.button_link.text}
                    >
                        {sliceItem.primary.button_name.text}
                    </Button>
                    )}
                </div>
                <div  className="sliderColorsShapes__MobileSWiper showOnTablet">
                    <ImageSliderSwiperjs slides={images}  />
                </div>
                <div className='ColorsGlazesShapes_ColorsGlazes_Slider showOnTablet'>
                    <ImageSlider slides={images} />
                </div>
            </div>
        </div>
    )

};

export default ColorsGlazesShapes;